import { render, staticRenderFns } from "./EvidenceCard.vue?vue&type=template&id=a201e7f0&scoped=true&"
import script from "./EvidenceCard.vue?vue&type=script&lang=js&"
export * from "./EvidenceCard.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceCard.vue?vue&type=style&index=0&id=a201e7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a201e7f0",
  null
  
)

export default component.exports